"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.noteLogPayloadSchema = exports.userNoteLogPayloadSchema = void 0;
const zod_1 = require("zod");
exports.userNoteLogPayloadSchema = zod_1.z.object({
    kind: zod_1.z.literal('user-note'),
    body: zod_1.z.string().min(1),
});
exports.noteLogPayloadSchema = exports.userNoteLogPayloadSchema;
//# sourceMappingURL=note-log-payload.js.map